import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const VALID = ["roadmap", "reports", "risks", "actions", "teams", "timeline", "map", "board", "baseline", "budget", "resources", "meeting", "plan", "notebook", "stakeholders", "process", "artifacts", "approvals", "audit", "raid", "radar"];

export default function ViewRedirect() {
  const { tab } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    const t = tab === "ioflow" ? "plan" : (VALID.includes(tab) ? tab : "plan");
    const extra = tab === "ioflow" ? "&view=flow" : "";
    api.get("/projects")
      .then(({ data }) => {
        if (data && data.length) {
          const last = localStorage.getItem("last-project-id");
          const pick = data.find((p) => p.id === last) || data[0];
          nav(`/projects/${pick.id}?tab=${t}${extra}`, { replace: true });
        } else {
          toast.info("Create your first project to use this view.");
          nav("/dashboard?new=1", { replace: true });
        }
      })
      .catch(() => nav("/dashboard", { replace: true }));
  }, [tab, nav]);

  return <div className="h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
}
